import { render, staticRenderFns } from "./ViewBankaccount.vue?vue&type=template&id=61f72b3e&"
import script from "./ViewBankaccount.vue?vue&type=script&lang=js&"
export * from "./ViewBankaccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports